import React, { useState, useEffect, useCallback, useRef } from "react";
import { StyleSheet, View } from "react-native";

import PredictionsList from "./PredictionsList";
import CurrentTimeIndicator from "./time/CurrentTimeIndicator";
import Utils from "../../../../helpers/utils";
import appStyles from "../../../appStyles";
import TutorialsHelper from "../../tutorials/TutorialsHelper";
import TimeslotItemTimes from "./TimeslotItemTimes";
import TimeslotConfirmedData from "./TimeslotConfirmedData";
import TimeslotPendingData from "./TimeslotPendingData";

export default function TimeSlotItem(props) {
  const {
    timeslot,
    journalContext,
    prevTimeslot,
    nextTimeslot,
    editMode,
    isHomeCard = false,
    today = null,
    showIcons = true,
    time = null,
    hasChunking = false,
    currentDateTime = null,
  } = props || {};

  const {
    controller,
    onTimeslotSelected = () => {},
    confirmTimeslot = () => {},
    expandTimeslot = () => {},
    isAutoReview = false,
    tutorialStep,
    integrationsTs,
    isBulkEdit,
  } = journalContext || {};

  const minutesInterval = controller.state?.settings?.interval_duration;
  const [timeslotModel, setUpdatedTimeslotModel] = useState(() => timeslot);

  // This is the fix that solves the stale timeslot end time issue
  useEffect(() => {
    setUpdatedTimeslotModel(timeslot);
  }, [timeslot]);

  const highlightFromSourceStyle =
    integrationsTs && integrationsTs.id === timeslot.id // If integration dialog if open highlight selected timeslot
      ? { backgroundColor: "#F6EC91" }
      : timeslot.confirmed && timeslot.auto_fill == 2 // from source
      ? timeslot.source == "atus"
        ? { backgroundColor: "rgba(64, 85, 132, 0.1)" }
        : { backgroundColor: "rgba(194, 233, 219, 0.2)" }
      : {};

  // ------------------------------------- TUTORIALS -------------------------------------
  const showTrackTutorials = (controller?.state?.showTutorials || {})[
    TutorialsHelper.STORAGE_KEYS.track
  ];

  const isTimeslotAutoReview =
    isAutoReview && Utils.isAutoTracked(timeslotModel);
  const hasAutoTrackedButton =
    isTimeslotAutoReview &&
    prevTimeslot != null &&
    (nextTimeslot == null || !Utils.isAutoTracked(nextTimeslot));
 /*  let hasEditableTime = !editMode && timeslotModel && timeslotModel.activity;

  if (!isHomeCard) {
    hasEditableTime =
      !editMode &&
      timeslotModel &&
      (timeslotModel.activity || timeslotModel.user_confirmed);
  } */

  // Called on edit journal entry page: Replace timeslot activity with a selected prediction or undo
  const onActivitySelected = (
    prediction,
    is_confirmed,
    wasPredicted = false,
    reload = false,
    source = null,
  ) => {
    if (isBulkEdit) return;

    const updatedTimeslot = {
      ...timeslotModel,
      activity: is_confirmed ? { ...prediction } : null,
      user_confirmed: is_confirmed,
      hidePredictions: is_confirmed,
      source: source,
    };

    if (!isHomeCard) {
      setUpdatedTimeslotModel(updatedTimeslot);
    }

    const wasFirstOption =
      updatedTimeslot.predicted_activities != null &&
      updatedTimeslot.predicted_activities.length > 0 &&
      updatedTimeslot.activity != null &&
      updatedTimeslot.predicted_activities[0] != null &&
      updatedTimeslot.activity.id == updatedTimeslot.predicted_activities[0].id;

    confirmTimeslot({
      timeslot: updatedTimeslot,
      is_confirmed,
      was_predicted: wasPredicted ? 1 : 0,
      was_first_option: wasFirstOption ? 1 : 0,
      reload,
    });
  };

  // Don't render anything
  if (!timeslotModel) {
    return null;
  }

  return (
    <View
      style={[
        appStyles.timeslotRow,
        highlightFromSourceStyle,
        editMode && { opacity: timeslot.isSelected ? 1 : 0.7 },
      ]}
    >
      {/* Start/End time */}
      <TimeslotItemTimes
        timeslot={timeslot}
        journalContext={journalContext}
        prevTimeslot={prevTimeslot}
        editMode={editMode}
        isHomeCard={isHomeCard}
        positionIndex={props.positionIndex}
        showEndTime={props.showEndTime}
        timeslotModel={timeslotModel}
      />

      {/* Current time indicator */}
      <CurrentTimeIndicator
        controller={controller}
        editMode={editMode}
        today={today}
        time={time}
        timeslot={timeslotModel}
      />

      {timeslotModel.activity ? (
        timeslotModel.user_confirmed || timeslotModel.autoconfirmed ? (
          <TimeslotPendingData
            timeslot={timeslotModel}
            journalContext={journalContext}
            onActivitySelected={onActivitySelected}
            editMode={editMode}
          />
        ) : (
          <TimeslotConfirmedData
            timeslot={timeslotModel}
            journalContext={journalContext}
            onActivitySelected={onActivitySelected}
            editMode={editMode}
            isAutoReview={isTimeslotAutoReview}
            hasAutoTrackedButton={hasAutoTrackedButton}
            isHomeCard={isHomeCard}
            showTrackTutorials={showTrackTutorials}
            currentDateTime={currentDateTime}
            hasChunking={hasChunking}
          />
        )
      ) : timeslotModel.predicted_activities &&
        !timeslotModel.hidePredictions ? (
        <PredictionsList
          timeslot={timeslotModel}
          onTimeslotSelected={onTimeslotSelected}
          onActivitySelected={onActivitySelected}
          minutesInterval={minutesInterval}
          expandTimeslot={expandTimeslot}
          hasChunks={hasChunking}
          tutorialStep={tutorialStep}
          showTrackTutorials={showTrackTutorials}
          showIcons={showIcons}
          {...props}
        />
      ) : null}
    </View>
  );
}
